import { ReactNode, useState } from 'react';
import { cx } from '../utils';

type ExpandableProps = {
  trigger: ({ isOpen, onClick }: { isOpen: boolean; onClick: () => void }) => ReactNode;
  content: () => ReactNode;
  externalState?: [boolean, () => void];
  className?: string;
};

export const useExpandableListState = () => {
  const [currentIndex, setCurrentIndex] = useState<null | number>(null);

  const expandableItemProps = (index: number): [boolean, () => void] => {
    return [
      currentIndex === index,
      () => setCurrentIndex((prev) => (prev === index ? null : index)),
    ];
  };

  return { expandableItemProps };
};

export const Expandable = ({ externalState, className, trigger, content }: ExpandableProps) => {
  const internalState = useState(false);
  const [isOpen, setIsOpen] = externalState ?? internalState;

  const handleClick = () => {
    if (isOpen && !document.getSelection()?.isCollapsed) {
      return;
    }

    setIsOpen((prev) => !prev);
  };

  return (
    <div className={cx(className, 'cursor-pointer')} onClick={handleClick}>
      {trigger({ isOpen, onClick: () => {} })}
      <div
        className={cx(
          'grid grid-cols-1 min-h-0 transition-brand origin-top',
          isOpen ? 'grid-rows-[1fr] visible opacity-100' : 'grid-rows-[0fr] opacity-0 invisible',
        )}
      >
        <div className="overflow-y-hidden">{content()}</div>
      </div>
    </div>
  );
};
